import { getAccessTokenWithFallback, initShellAuth, } from '@harleys/shell-client';
import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
const CLIENT_ID = import.meta.env.VITE_AAD_CLIENT_ID;
const TENANT_ID = import.meta.env.VITE_AAD_TENANT_ID;
const API_SCOPE = import.meta.env.VITE_API_SCOPE;
initShellAuth();
const msal = new PublicClientApplication({
    auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: window.location.origin,
    },
    cache: { cacheLocation: 'sessionStorage' },
});
let ready = false;
function decodeJwt(token) {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(atob(base64).split('').map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
    return JSON.parse(json);
}
async function msalFallback() {
    if (!ready) {
        await msal.initialize();
        await msal.handleRedirectPromise();
        ready = true;
    }
    let account = msal.getAllAccounts()[0];
    if (!account)
        account = (await msal.loginPopup({ scopes: [API_SCOPE] })).account;
    try {
        const result = await msal.acquireTokenSilent({ scopes: [API_SCOPE], account });
        const claims = decodeJwt(result.accessToken);
        return { token: result.accessToken, expiresAt: claims.exp * 1000 };
    }
    catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
            const result = await msal.acquireTokenPopup({ scopes: [API_SCOPE] });
            const claims = decodeJwt(result.accessToken);
            return { token: result.accessToken, expiresAt: claims.exp * 1000 };
        }
        throw err;
    }
}
export async function getAccessToken() {
    return getAccessTokenWithFallback(msalFallback);
}
